/* yyyymmddT */

/*================================
=            Minicart            =
================================*/
function customMinicart(){
	'use strict';
	var $mainSelector = $('#mini-cart-admake-aux');
	var $amount = $mainSelector.find('.amount-items-em');
	var timeoutToHide = 800;
	var timerHide;

	function createMiniCart() {
		$mainSelector
			.removeData()
			.off()
			.minicart({
				showMinicart: true,
				showTotalizers: true,
				showShippingOptions: false
			});
		$(window).on('minicartLoaded.vtex', function(){
			fixesSetupMiniCart();
		});

		$mainSelector.on('minicartUpdated.vtex', function(){
			updateEmptyCartHeader();
		});

		setTimeout(function() {
			$('.carrinhoCompras').on('mouseenter', function() {
				$('a.cartCheckout').prop('href', '/checkout/#/cart');
			});
		}, 1000);

		triggerBtnBuy();
	}

	function updateEmptyCartHeader() {
		if (!!vtexjs.checkout.orderForm) {
			if (!((vtexjs.checkout.orderForm || {}).items || []).length) {
				try {
					vtexjs.checkout.orderForm = undefined;
				} catch (e) {
					console.log(e);
				}
				$mainSelector.addClass('isEmpty');
				// return false;
			} else {
				$mainSelector.removeClass('isEmpty');
				// return true;
			}
		}

		var $links = $('.cart-link, .cart-open');
		var len = ((vtexjs.checkout.orderForm || {}).items || []).length;

		if (!len) {
			$links.find('.counter').remove();
			return false;
		}

		$links.each(function(i, e) {
			var $e = $(e);
			var $counter = $e.find('.counter');

			if (!$counter.length) {
				$counter = $('<span class="counter"></span>');
				$e.append($counter);
			}

			$counter.html(len);
		});
	}

	function fixesSetupMiniCart(){
		updateEmptyCartHeader();
		$mainSelector.find('.vtexsc-cart').removeAttr('style');
	}

	function triggerBtnBuy() {
		$(document).on('click', '.buy-in-page-button', function (e) {
			var $btn = $(this);
			var redirect = (($btn.data('buyButton') || {}).options || {}).redirect;
			
			if (!redirect) {
				e.preventDefault();
				var button = $(this);
				var hrefButton = $(button).attr('href') || '';
				var params = getQueryParams(hrefButton.split('#')[0].split('?')[1] || '');

				if (!params || !params.sku) {
					alert('Por favor, selecione uma opção antes de prosseguir');
				}

				var item = {
					id: params.sku,
					quantity: params.qty || 1,
					seller: params.seller || 1
				};
				vtexjs.checkout
					.addToCart([item], null, (params.sc || 1))
					.done(function (orderForm) {
						updateEmptyCartHeader();
						$('.cart-open:eq(0)').trigger('click');
					});
			}
		});
	}

	if ($mainSelector.length) {
		$mainSelector.addClass('forceHideMiniCart');

		createMiniCart();
	}
}

/*=====  End of Minicart  ======*/

// https://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function customDebounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};
function fixInputQty($input) {
	var $wrap = $('<div class="quantity"></div>');
	$input.prop('type', 'tel');
	$input.prop('min', 1);
	$input.prop('max', 99999);
	$input.wrapAll($wrap);
	var $buttons = $('<div class="quantity-nav"><button class="quantity-button quantity-up"><span>+</span></button><button class="quantity-button quantity-down"><span>-</span></button></div>');
	var $btnUp = $buttons.find('.quantity-up');
	var $btnDown = $buttons.find('.quantity-down');
	var min = $input.attr('min');
	var max = $input.attr('max');

	$btnUp.on('click', function(event) {
		event.preventDefault();
		var oldValue = parseFloat($input.val());
		if (oldValue >= max) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue + 1;
		}
		$input.val(newVal);
		$input.trigger("change");
	});

	$btnDown.on('click', function(event) {
		event.preventDefault();
		var oldValue = parseFloat($input.val());
		if (oldValue <= min) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue - 1;
		}
		$input.val(newVal);
		$input.trigger("change");
	});
	$buttons.insertAfter($input);
}

/**
 * jQuery serializeObject
 * @copyright 2014, macek <paulmacek@gmail.com>
 * @link https://github.com/macek/jquery-serialize-object
 * @license BSD
 * @version 2.5.0
 */
!function(e,i){if("function"==typeof define&&define.amd)define(["exports","jquery"],function(e,r){return i(e,r)});else if("undefined"!=typeof exports){var r=require("jquery");i(exports,r)}else i(e,e.jQuery||e.Zepto||e.ender||e.$)}(this,function(e,i){function r(e,r){function n(e,i,r){return e[i]=r,e}function a(e,i){for(var r,a=e.match(t.key);void 0!==(r=a.pop());)if(t.push.test(r)){var u=s(e.replace(/\[\]$/,""));i=n([],u,i)}else t.fixed.test(r)?i=n([],r,i):t.named.test(r)&&(i=n({},r,i));return i}function s(e){return void 0===h[e]&&(h[e]=0),h[e]++}function u(e){switch(i('[name="'+e.name+'"]',r).attr("type")){case"checkbox":return"on"===e.value?!0:e.value;default:return e.value}}function f(i){if(!t.validate.test(i.name))return this;var r=a(i.name,u(i));return l=e.extend(!0,l,r),this}function d(i){if(!e.isArray(i))throw new Error("formSerializer.addPairs expects an Array");for(var r=0,t=i.length;t>r;r++)this.addPair(i[r]);return this}function o(){return l}function c(){return JSON.stringify(o())}var l={},h={};this.addPair=f,this.addPairs=d,this.serialize=o,this.serializeJSON=c}var t={validate:/^[a-z_][a-z0-9_]*(?:\[(?:\d*|[a-z0-9_]+)\])*$/i,key:/[a-z0-9_]+|(?=\[\])/gi,push:/^$/,fixed:/^\d+$/,named:/^[a-z0-9_]+$/i};return r.patterns=t,r.serializeObject=function(){return new r(i,this).addPairs(this.serializeArray()).serialize()},r.serializeJSON=function(){return new r(i,this).addPairs(this.serializeArray()).serializeJSON()},"undefined"!=typeof i.fn&&(i.fn.serializeObject=r.serializeObject,i.fn.serializeJSON=r.serializeJSON),e.FormSerializer=r,r});


function getQueryParams(a){var a=a.split("+").join(" "),d={},c,b=/[?&]?([^=]+)=([^&]*)/g;while(c=b.exec(a)){d[decodeURIComponent(c[1])]=decodeURIComponent(c[2])}return d};

/*
https://gist.github.com/jeffdrumgod/5788907
http://stackoverflow.com/a/2866613
decimal_sep: character used as deciaml separtor, it defaults to '.' when omitted
thousands_sep: char used as thousands separator, it defaults to ',' when omitted
*/
Number.prototype.toMoney = function(decimals, decimal_sep, thousands_sep)
{
   var n = this,
   c = isNaN(decimals) ? 2 : Math.abs(decimals), //if decimal is zero we must take it, it means user does not want to show any decimal
   d = decimal_sep || '.', //if no decimal separator is passed we use the dot as default decimal separator (we MUST use a decimal separator)

   /*
   according to [http://stackoverflow.com/questions/411352/how-best-to-determine-if-an-argument-is-not-sent-to-the-javascript-function]
   the fastest way to check for not defined parameter is to use typeof value === 'undefined' 
   rather than doing value === undefined.
   */   
   t = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep, //if you don't want to use a thousands separator you can pass empty string as thousands_sep value

   sign = (n < 0) ? '-' : '',

   //extracting the absolute value of the integer part of the number and converting to string
   i = parseInt(n = Math.abs(n).toFixed(c)) + '', 

   j = ((j = i.length) > 3) ? j % 3 : 0; 
   return sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : ''); 
}
if (!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	};
}

String.prototype.cleanFromMoney = function(currencyCode, decimal_sep, thousands_sep)
{
	currencyCode = (currencyCode || 'R$');
	decimal_sep = (decimal_sep || ',');
	thousands_sep = (thousands_sep || '.');

	return (this || '').replace('R$','').replace(thousands_sep, '').replace(decimal_sep, '.').trim();
}